import { render } from "./blogs-modal.vue?vue&type=template&id=2cccedb6"
import script from "./blogs-modal.vue?vue&type=script&lang=js"
export * from "./blogs-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__